import React, { useEffect, useState } from 'react'
import { IntlProvider } from 'react-intl'
import { flattenTranslationFile } from './i18nTransformation'

import * as messages from 'assets/translations'

const DEFAULT = {
  language: 'en',
  locale: 'en-US',
  supportedLanguages: new Set(['de', 'en', 'es', 'fr', 'ja', 'ko', 'pt']),
}

const getLanguages = (): readonly string[] | string[] => {
  if (
    window.navigator &&
    window.navigator.languages &&
    window.navigator.languages.length > 0
  ) {
    return window.navigator.languages
  }

  if (window.navigator && window.navigator.language) {
    return [window.navigator.language]
  }

  return [DEFAULT.locale]
}

export function I18N({ children }) {
  const [localeData, setLocale] = useState({
    language: DEFAULT.language,
    locale: DEFAULT.locale,
  })
  const [translations] = useState(flattenTranslationFile(messages))

  useEffect(() => {
    // The preferred locale will always be the first element in the array
    const [preferredLocale] = getLanguages()
    // The language will always be the first two characters of the locale
    const selectedLanguage = preferredLocale.slice(0, 2)

    // Fall back to the default if the preferred language is unsupported
    const preferredLanguage = DEFAULT.supportedLanguages.has(selectedLanguage)
      ? selectedLanguage
      : DEFAULT.language

    setLocale(() => ({
      language: preferredLanguage,
      locale: preferredLocale,
    }))
  }, [])

  const translationSet = translations[localeData.language]
  return (
    <IntlProvider locale={localeData.locale} messages={translationSet}>
      {children}
    </IntlProvider>
  )
}
